/**
 * Ist auf dem Server eine neuere Oberfläche als die, die gerade läuft?
 *
 * Nach dem Update vom 24.10.2026 arbeitete ein Reiter unbemerkt mit der alten
 * Oberfläche weiter; beide zeigten „Version 0.2.0“ (Testgrundlage 2.2, B-01).
 * Der Build schreibt deshalb `version.json` mit einer Build-Kennung, und die
 * laufende Oberfläche kennt ihre eigene (`__APP_BUILD__`). Weichen sie ab, gibt
 * es eine neuere — NewVersionNotice zeigt dann ein Band mit „Neu laden“.
 *
 * Gefragt wird beim Start (eine zwischengespeicherte alte index.html fällt so
 * sofort auf), wenn das Fenster den Fokus bekommt, und alle fünf Minuten.
 */
export const VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

/** Die Build-Kennung auf dem Server — `null`, wenn sie nicht zu lesen ist. */
export async function fetchServerBuild(): Promise<string | null> {
  try {
    const antwort = await fetch(`${import.meta.env.BASE_URL ?? '/'}version.json`, {
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!antwort.ok) return null;
    // Ohne version.json liefert der Server die Startseite (SPA-Fallback) —
    // das ist keine Auskunft über die Version, sondern keine. Am Inhalt
    // erkannt, nicht am Content-Type: den setzt nicht jeder Server für .json.
    const text = (await antwort.text()).trim();
    if (!text.startsWith('{')) return null;
    const daten = JSON.parse(text) as { build?: unknown };
    return typeof daten?.build === 'string' && daten.build ? daten.build : null;
  } catch {
    return null;
  }
}
